import React, { createContext, FC, ReactNode, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { IDealerPermissions } from './DealerPermisssions';
import {logout } from './logout';
export interface IUserProps {
	id: Number;
	bankDetails: string;
	firstName: string;
	lastName: string;
	userTypeId: Number;
	parentId: Number;
	forceChangePW: boolean;
	demo: boolean;
	termsAccepted: boolean;
	userName: string;
	userType: string;
	gmtOffset: string;
	accountId: Number;
	serverGmtOffset: string;
	token: string;
	clientCurrencyPolicyIdNodes: [Number];
	clientGenericPolicyIdNodes: [Number];
	dealerCurrencyPolicyIdNodes: [Number];
	dealerGenericPolicyIdNodes: [Number];
	roboDealerPolicyIdNodes: [Number];
	accountMirroringPolicyIdNodes: [Number];
	agentCommissionPolicyIdNodes: [Number];
	clientTreeUserIdNode: [Number];
	isMultiSession: boolean;
	canTransferMoney: boolean;
	amountScaleValue: Number;
	redisKey: string;
	creditLoanPercentage: Number;
	enableCashDelivery: boolean;
	enableDepositRequest: boolean;
	userCurrencyId: Number;
	loginTime: Number;
	canTransferPosition: boolean;
}
export interface IAuthContextProps {
	user: string;
	setData?(...args: unknown[]): unknown;
	userData: Partial<IUserProps>;
	setDealerData?(...args: unknown[]): unknown;
	dealerPermissions: Partial<IDealerPermissions>;
}

const AuthContext = createContext<IAuthContextProps>({} as IAuthContextProps);

interface IAuthContextProviderProps {
	children: ReactNode;
}
export const AuthContextProvider: FC<IAuthContextProviderProps> = ({ children }) => {
	const [user, setUser] = useState<string>(localStorage.getItem('ark_authUsername') || '');
	const [userData, setUserData] = useState<Partial<IUserProps>>(
		JSON.parse(localStorage.getItem('ark_authUser') || '{}'),
	);
	const [dealerPermissions, setDealerPermission] = useState<Partial<IDealerPermissions>>(
		JSON.parse(localStorage.getItem('ark_DealerPermission') || '{}') || {},
	);
	useEffect(() => {
		localStorage.setItem('ark_authUsername', user);
	}, [user]);
	useEffect(() => {
		localStorage.setItem('ark_DealerPermission', JSON.stringify(dealerPermissions));
	}, [dealerPermissions]);
	useEffect(() => {
		localStorage.setItem('ark_authUser', JSON.stringify(userData));
	}, [userData]);

	useEffect(() => {
		if (user === '' || user === undefined) {
			setUserData({});
		}
	}, [user]);

	const setData = async (data: any) => {
		if (data !== '') {
			setUser(data.userName);
			setUserData(data);
			localStorage.setItem('ark_authToken', data.token);
			localStorage.setItem('ark_current_bank_details', data.bankDetails);
		} else {
			await logout();
		}
	};

	const setDealerData = (data: any) => {
		if (data !== '') {
			setDealerPermission(data);
		}
	};
	const value = useMemo(
		() => ({
			user,
			setData,
			userData,
			setDealerData,
			dealerPermissions,
		}),
		[user, userData, dealerPermissions],
	);
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

AuthContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AuthContext;
